import { forwardRef } from "react";

import classNames from "classnames";
import type { ButtonHTMLAttributes, ReactNode } from "react";
import type React from "react";

import { Spinner } from "../Spinner/Spinner";

import style from "./Button.module.css"; // eslint-disable-line

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "grayscale" | "red" | "borderless";
  loading?: boolean;
  children?: ReactNode;
}

export const Button = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement> & ButtonProps
>(({ variant = "primary", loading, children, ...attrs }, ref) => {
  return (
    <button
      type="button"
      {...attrs}
      disabled={loading || attrs.disabled}
      ref={ref}
      className={classNames(
        style.button,
        style[variant],
        loading && style.loading,
        attrs.className
      )}
    >
      {loading && <Spinner size={18} className={style.spinner} />}
      {children}
    </button>
  );
});

Button.displayName = "Button";

export const ButtonIconWithLabel: React.FC<{ icon: ReactNode; label: string }> = ({
  icon,
  label,
}) => {
  return (
    <div className={style.buttonIconWithLabel}>
      {icon}
      <span>{label}</span>
    </div>
  );
};
